import React from "react";

import { Icon, Warning } from "@culturehq/components";
import { Trans } from "app/utils";

const TiktokMessage = ({ isTiktokShareable }) => {
  if (isTiktokShareable) {
    return (
      <div className="TipContainer">
        <Icon icon="info" />
        <div>
          <p>
            <Trans>
              You will add the message on the TikTok app.
            </Trans>
          </p>
        </div>
      </div>
    );
  }

  return (
    <Warning>
      <Trans>
        Tiktok only allows videos with at least 3 seconds and at most 60 seconds.
        You have to trim the video if you want to share it to TikTok
      </Trans>
    </Warning>
  );
};

export default TiktokMessage;
